import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { CustomerPreviewDialogComponent } from './customer-preview-dialog/customer-preview-dialog.component';
import { FileUploadService } from 'src/app/services/shared/file-upload.service';
import { ShareResumeComponent } from '../shared/share-resume/share-resume.component';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';




@Component({
  selector: 'app-end-customer',
  templateUrl: './end-customer.component.html',
  styleUrls: ['./end-customer.component.scss']
})
export class EndCustomerComponent implements OnInit {

handleWorkExperience($event: Event) {
throw new Error('Method not implemented.');
}

  @Output() workExperienceChanged = new EventEmitter<boolean>();
  @Input() selectedTabIndex: number = 0;
  @Input() addAction: boolean = false;
  tabName!: string;

  showSavedJobs!: boolean;
  applicantId: any;
  userName: any;

  messages: any = [];
  isEnquiry:boolean = false;
  isProductEnquiry: boolean = false;
  endCustomerType: string = '';
  backToSavedJobs: boolean = false;
  backToAppliedJobs:boolean = false;
  roleName: string = '';

  constructor(private readonly endCustomerService: EndCustomerService,
    private readonly localStorageService: LocalStorageService,private dialog: MatDialog , private fileUploadService: FileUploadService , private spinnerService: SpinnerService, private router: Router , private route: ActivatedRoute,  private breakPointObserver: BreakpointObserver) {
      this.roleName = localStorageService.getItem('roleName');
    if (this.roleName === 'USER') {
      this.route.queryParams.subscribe(params => {
        if (!params['tabName']) {
          this.tabName = 'home';
          this.router.navigate(['/'], { queryParams: { tabName: this.tabName }, queryParamsHandling: 'merge', replaceUrl: true });
        }
      });
    }
    }

     ngOnInit(): void {
      this.checkAllBreakPoints();

      this.localStorageService.getUserDetails().subscribe((data: any) => {
        this.getEndCustomerByUserId(data.userId);
      });
    
      this.isProductEnquiry = window.history?.state.isProductEnquiry;
      if (this.isProductEnquiry) {
        this.tabName = 'productEnquiry';
        this.isProductEnquiry = false;
      }
    
      this.backToSavedJobs = window.history?.state.backToSavedJobs;
      if (this.backToSavedJobs) {
        this.tabName = 'profileJobs';
        this.showSavedJobs = this.backToSavedJobs;
      }
    
      this.backToAppliedJobs = window.history?.state.backToAppliedJobs;
      if (this.backToAppliedJobs) {
        this.tabName = 'profileJobs';
        this.backToAppliedJobs = this.backToAppliedJobs;
      }
    
      if (!this.tabName) {
        this.tabName = window.history?.state.tabName || 'myProfile';
      }
      this.navigationURL(this.tabName)
    }

    navigationURL(tabname: any){
      this.route.queryParams.subscribe(params => {
       const _tabName = params['tabName'];
        if (_tabName) {
          this.tabName = _tabName;
        }
      });

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { tabName: tabname },
        queryParamsHandling: 'merge'
      });
    }

    mobileView: boolean = false;
    
    checkAllBreakPoints() {
      this.breakPointObserver.observe([
        '(max-width: 767.98px)'
      ]).subscribe(r => {
        if(r.matches) {
          if(r.breakpoints['(max-width: 767.98px)']) {
            this.resetScrollSettings();
            this.mobileView = true;
          }
        }
      })
    }

    resetScrollSettings(): void {
      setTimeout(() => {
        const body = document.body;
        const html = document.documentElement;
   
        body.style.overflow = 'auto';
        html.style.overflow = 'auto';
      });
    }

  activateCurrentab(selectedName: string): void {
    this.tabName = selectedName;
    this.navigationURL(selectedName);
  }

  removeTabNameFromQueryParams(): void {
    this.router.navigate([], {
      queryParams: { tabName: null },
      queryParamsHandling: 'merge'  
    });
  }

  JobId: string = '';
  actionView(event: any){
    this.JobId = event;
    this.tabName = 'viewJob';
  }

  viewJobApplicationsId!: string;

  selectedAction(event: any){
    switch (event.type) {
      case 'add': 
        this.tabName = 'postJob';
        break;
      case 'update':
        this.JobId = event.id;
        this.tabName = 'updateJob';
        break;
      case 'viewJobApplications':
        this.viewJobApplicationsId = event.id;
        this.tabName = 'viewJobApplications';
        break;
      default:
        break;
    }
  }

  actionUpdate(event: any){
    this.JobId = event;
    this.tabName = 'postJob';
  }
  viewAllJobs: string = '';

  showAllJobs(event: any){
    this.tabName = 'ViewAllJobs';
  }

  applicationDetails: any;
  fromViewAllJobAllicationsAction(event: any){
    switch (event.type) {
      case 'back':
        this.showAllJobs(true);
        break;
      
      case 'view':
        this.tabName = 'applicationDetails';
        this.applicationDetails = event;
        break;
      case 'file':
        this.tabName = 'applicationDetails';
        this.applicationDetails = event;
        break;
      default:
        break;
    }
  }

  applicationDetailsAction(event: any){

  }

  postAJob(event: any){
    this.tabName = 'postJob';
  }

 

  messageFromPostJob(event: any){
    if(event === 'cancel'){
      this.tabName = 'ViewAllJobs';
    }
  }

  backToAllJobs(event: any){
    this.tabName = 'ViewAllJobs';
  }

  public downloadResumefromHtml(): void {
    this.downloadPdf('carrers', 'Resume', true);

  }
 
  public downloadPdf(htmlElementId: string, pdfFileName: string, isDownload: boolean = true): Promise<Blob | void> {
    return new Promise((resolve, reject) => {
      const element = document.getElementById(htmlElementId);
 
      if (element) {
        const validatedElement = this.validatingDataSectionWise(element);

        html2canvas(validatedElement, { scale: 1 }).then((canvas) => {
          const imgData = canvas.toDataURL('image/jpeg', 0.7);
          const pdf = new jsPDF('p', 'mm', 'a4');
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
         this.userName = validatedElement.querySelector('#user-name')?.textContent;
          pdfFileName = this.userName ? `${this.userName} - ${pdfFileName}` : 'Resume';
          const margin = 10;
          const usableWidth = pdfWidth - 2 * margin;
          const usableHeight = pdfHeight - 2 * margin;
  
          const imgProps = pdf.getImageProperties(imgData);
          const imgWidth = usableWidth;
          const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
  
          let heightLeft = imgHeight;
          let position = margin;
          pdf.addImage(imgData, 'JPEG', margin, position, imgWidth, imgHeight, undefined, 'FAST');
          heightLeft -= usableHeight;
  
          while (heightLeft > 0) {
            pdf.addPage();
            position = heightLeft - imgHeight + margin;
            pdf.addImage(imgData, 'JPEG', margin, position, imgWidth, imgHeight, undefined, 'FAST');
            heightLeft -= usableHeight;
          }
  
    
          if (isDownload) {
            pdf.save(`${pdfFileName}.pdf`);
            resolve(); 
          } else {
            const pdfBlob = pdf.output('arraybuffer'); 
            const blob = new Blob([pdfBlob], { type: 'application/pdf' }); 
            resolve(blob);
          }
        }).catch((error) => {
          reject(error);
        });
      } else {
        reject(new Error('Element not found'));
      }
    });
  }
  


  


  public async shareResume(): Promise<void> {
    try {
  this.spinnerService.showSpinner('Loading...');
      const pdfBlob = await this.downloadPdf('carrers', 'Resume', false); 
  
      if (pdfBlob instanceof Blob) {
        const formData = new FormData();
        formData.append('file', pdfBlob , 'Resume-'+new Date().toISOString()+'.pdf');
        formData.append('destinationKey', 'resumes/');
  
        this.fileUploadService.uploadFile(formData).subscribe((response) => {
          if (response && response.data) {
            const url = response.data;
            this.spinnerService.hideSpinner();
            this.dialog.open(ShareResumeComponent, {
              width: '23%',
              height: '15%',
              position: { top: '24%', left: '35%' },
              data: { url  : url  ,
                user : this.userName
              }
              
            })
          }
        });
      } else {
      }
    } catch (error) {
    }
  }
  

  openPreview(htmlElementId: string): void {
    const element = document.getElementById(htmlElementId);
  
    if (element) {
      const htmlContent = element.innerHTML;
      this.dialog.open(CustomerPreviewDialogComponent, {
        width: '65%',
        autoFocus:false,
        position:{top:'40px'},
        data: { htmlContent }
      });
    } else {
    }
  }

  private getEndCustomerByUserId(userId: any) {
    this.endCustomerService.executeGetRequestURL(MweConstants.getCustomerByUserId + userId, null).subscribe({
      next: (response: any) => {
        this.endCustomerType = response.data.account.accountType.name;
        if (response && response?.data) {
          this.applicantId = response?.data.id;
        }
      }, error: (error: any) => {}
    });
  }
  
  showMyProfileJobs(event: boolean) {
    this.tabName = "profileJobs";
    this.showSavedJobs = event;
  }
  onWorkExperience(event : {type: string, value: boolean})  {
    const type= event.type;
    this.tabName = "myProfile";
    setTimeout(() => {
      if (type === 'work') {
        const workingExperiencesElement = document.getElementById('workingExperiences') as HTMLElement;
        if (workingExperiencesElement) {
          workingExperiencesElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else if (type === 'education') {
        const educationElement = document.getElementById('education') as HTMLElement;
        if (educationElement) {
          educationElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      else if(type === 'Specialities') {
        const specialitiesElement = document.getElementById('specialities') as HTMLElement;
        if (specialitiesElement) {
          specialitiesElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      else if(type === 'Services') {
        const servicesElement = document.getElementById('services') as HTMLElement;
        if (servicesElement) {
          servicesElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, 500);
        }

       
        private validatingDataSectionWise(element: HTMLElement): HTMLElement {
          const sectionMap: { [key: string]: string } = {
            '#add-work-experience': '#work-experience',
            '#add-education-details': '#education',
            '#add-skill-set-details': '#skill-set',
            '#add-certification-details': '#certifications',
            '#add-speciality-details': '#specialities',
            
            '#add-publication-details': '#publications',
            '#add-awards-honors': '#awards',
            '#add-associations-organizations': '#associations',
            '#add-volunteering-causes': '#volunteering',
            '#add-courses-training': '#courses',
            '#add-resume': '#resume',
            '#edit-icon': '#edit-icon',
            '#add-icon': '#add-icon',
            '#edit-icon2': '#edit-icon2',
            '#edit-icon3': '#edit-icon3',
            '#edit-icon4': '#edit-icon4',
            '#add-icon4': '#add-icon4',
            '#edit-icon5': '#edit-icon5',
            '#add-icon5': '#add-icon5',
            '#edit-icon6': '#edit-icon6',
            '#edit-icon7': '#edit-icon7',
            '#add-icon7': '#add-icon7',
            '#edit-icon8': '#edit-icon8',
            '#add-icon8': '#add-icon8',
            '#edit-icon9': '#edit-icon9',
            '#add-icon9': '#add-icon9',
            '#edit-icon10': '#edit-icon10',
            '#add-icon10': '#add-icon10',
            '#edit-icon11': '#edit-icon11',
            '#add-icon11': '#add-icon11',
            '#edit-icon12': '#edit-icon12',
            '#add-icon12': '#add-icon12',
            '#edit-icon13': '#edit-icon13',
            '#add-icon13': '#add-icon13',
          };
          const hideSection = (buttonId: string, sectionId: string) => {
            if (element.querySelector(buttonId)) {
              const section = element.querySelector(sectionId);
              if (section) {
                
                
                section.classList.add('hide-section');
               
              }
            }
          };
      
          Object.entries(sectionMap).forEach(([buttonId, sectionId]) => {
            hideSection(buttonId, sectionId);
          });
      
          return element; 
        }
      }
 
  